import React from 'react';
import { useEffect, useState } from "react";
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import DocumentCard from './DocumentCard'; // Assuming you have a DocumentCard component
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';

const darkThemeModal = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    backgroundColor: "#ooo",
    padding: "24px", // Increased padding
    borderRadius: "8px",
    color: "#ccc",
    minWidth: "50%", // Increased width
    maxWidth: "80%", // Increased width
    maxHeight: "80%", // Set maximum height
    overflowY: "auto", // Enable vertical scrolling if needed
  },
  documentCard: {
    backgroundColor: "#444",
    padding: "16px",
    borderRadius: "8px",
    marginBottom: "16px",
  },
}

const StrategyFetchingNotificationModal = ({ open, handleClose}) => {
  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={open}
      onClose={handleClose}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
      sx={darkThemeModal.modal}
    >

      <Fade in={open}>
        <Box sx={darkThemeModal.modalContent} >
        <div className="modal-dialog modal-dialog-centered">
            <div className="border modal-content-1 upgrade-modal-content  login_modal_wrapper  min-height-bookmark " >
                <div className="modal-header">
                    <h5 className="modal-title">🔄 Your Strategy is in Progress 🔄</h5>
                    <button type="button" className="btn-close  btn-close-white left-col-space text-white" onClick={handleClose}></button>
                </div>
                    <div className="modal-body text-center">
                    <p> We're on it! Your strategy is currently being executed. This process may take 10-15 mins to run.</p>
                    <p> While you wait, feel free to explore other sections of our platform.</p>
                    <p> We'll notify you as soon as your strategy has finished running.</p>
                    </div>
                <div className="modal-footer">
                    <a className="btn secondary_btn" href="/users/workspace/" id="strategy-link-button">View Dashboards</a>
                </div>
            </div>
        </div>
        </Box>
      </Fade>
    </Modal>
  );
};

export default StrategyFetchingNotificationModal;